import React, {FC} from 'react';
import {ICategory} from "../../interfaces";
import {NavLink} from "react-router-dom";
import {backURL} from "../../consts";
import {useTranslation} from "react-i18next";

interface ICategoryProps {
    category: ICategory
}

const Category: FC<ICategoryProps> = ({category}) => {
    const {t} = useTranslation()

    return (
        <NavLink className="category_card" to={`products/${category.name_}`}>
            <div className="category_card_img">
                <img src={`${backURL}/${category.img}`} alt={t(`categories.${category.name_}`) || ''} />
            </div>
            <div className="category_card_name">{t(`categories.${category.name_}`)}</div>
        </NavLink>
    );
};

export default Category;
